import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withKeys as _withKeys, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import {inject, onMounted, ref} from 'vue'
import {AxiosStatic} from "axios";
import DataTable, {DataTableFilterEvent, DataTablePageEvent} from 'primevue/datatable';
import InputText from 'primevue/inputtext'
import Message from 'primevue/message'
import Column from 'primevue/column';

// Define injects

export default /*#__PURE__*/_defineComponent({
  __name: 'ListProjectTable',
  setup(__props, { expose }) {


const axios = inject<AxiosStatic>('axios')

// Define properties
const projects = ref<any[]>([])
const loading = ref<boolean>(true)
const dt = ref(null);
const pageIndex = ref<number>(0)
const pageSize = ref<number>(25)
const totalRecords = ref<number>(0)
const filters = ref({
  companyName: {value: '', matchMode: 'contains'},
  name: {value: '', matchMode: 'contains'}
})

// Define lifecycle hooks
onMounted(() => {
  loadData()
})

// Define methods
function loadData(filterData: any = {}) {
  loading.value = true
  axios?.post("/datatable/projects?sort=name&page=" + pageIndex.value + "&pageSize=" + pageSize.value, filterData)
      .then((response) => {
        if (response.status === 200) {
          projects.value = response.data.rows
        }
        totalRecords.value = response.data.paginator.totalRecords
        loading.value = false
      }).catch(error => {
    console.error('Can not load projects', error)
    loading.value = false
  })
}

function onPage(event: DataTablePageEvent) {
  pageIndex.value = event.page
  loadData()
}

function onFilter(event: DataTableFilterEvent) {
  loadData(mapFilterToDataTablePayload(filters.value))
}

function mapFilterToDataTablePayload(vueFilter: any): any {
  const filter: any = {}
  const keys = Object.keys(vueFilter)
  for (let a = 0; a < keys.length; a++) {
    const key = keys[a]
    const {value: _value, matchMode} = vueFilter[keys[a]]

    if (_value.length > 0) {
      filter[key] = {
        type: getFilterType(matchMode),
        value: '%' + _value + '%'
      }
    }
  }
  return filter
}

function getFilterType(vueType: string): string {
  switch (vueType.toUpperCase()) {
    case 'CONTAINS':
      return 'like'
    default:
      return '='
  }
}

function reload() {
  loadData(mapFilterToDataTablePayload(filters.value))
}

expose({reload})



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (projects.value.length==0)
      ? (_openBlock(), _createBlock(_unref(Message), {
          key: 0,
          closable: false,
          severity: "info"
        }, {
          default: _withCtx(() => [
            _createTextVNode("There is not any projects in database")
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (projects.value.length>0)
      ? (_openBlock(), _createBlock(_unref(DataTable), {
          key: 1,
          class: "mt-2 mb-2",
          page: pageIndex.value+1,
          ref_key: "dt",
          ref: dt,
          dataKey: "id",
          rowHover: true,
          value: projects.value,
          lazy: true,
          paginator: true,
          rows: pageSize.value,
          totalRecords: totalRecords.value,
          filterDisplay: "row",
          filters: filters.value,
          "onUpdate:filters": _cache[0] || (_cache[0] = ($event: any) => ((filters).value = $event)),
          onPage: _cache[1] || (_cache[1] = ($event: any) => (onPage($event))),
          onFilter: _cache[2] || (_cache[2] = ($event: any) => (onFilter($event))),
          loading: loading.value
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Column), {
              field: "id",
              header: "ID"
            }),
            _createVNode(_unref(Column), {
              field: "name",
              header: "PROJECT NAME",
              filterMatchMode: "startsWith",
              ref: "companyName"
            }, {
              filter: _withCtx(({filterModel,filterCallback}) => [
                _createVNode(_unref(InputText), {
                  type: "text",
                  modelValue: filterModel.value,
                  "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                  onKeydown: _withKeys(($event: any) => (filterCallback()), ["enter"]),
                  class: "p-column-filter p-inputtext-sm",
                  placeholder: "Search by project name"
                }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeydown"])
              ]),
              _: 1
            }, 512),
            _createVNode(_unref(Column), {
              field: "companyName",
              header: "COMPANY"
            }, {
              filter: _withCtx(({filterModel,filterCallback}) => [
                _createVNode(_unref(InputText), {
                  type: "text",
                  modelValue: filterModel.value,
                  "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                  onKeydown: _withKeys(($event: any) => (filterCallback()), ["enter"]),
                  class: "p-column-filter p-inputtext-sm",
                  placeholder: "not implemented yet"
                }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeydown"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["page", "value", "rows", "totalRecords", "filters", "loading"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})